module.exports = __webpack_public_path__ + "img/母亲.3d889eda.png";